import {
  FILLUSERINFO,
  ASYNC_GET_ACCESSTOKEN,
  ASYNC_GET_AREA,
  ASYNC_GET_APPKEY,
} from '../actions/user';

const initialState = {
  accesstoken: null,
  userInfo: 'init',
  appKey: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ASYNC_GET_ACCESSTOKEN:
      return { ...state, accessToken: action.data };
    case ASYNC_GET_APPKEY:
        return { ...state, appKey: action.data };
    case FILLUSERINFO:
      return { ...state, userInfo: action.data};
    case ASYNC_GET_AREA:
        return { ...state, area: action.data };
    default:
      return state;
  }
};
